import * as Sentry from '@sentry/react'
import localforage from 'localforage'
import {applyMiddleware, compose, createStore} from 'redux'
import {persistReducer, persistStore} from 'redux-persist'
import createMigrate from 'redux-persist/es/createMigrate'
import createSagaMiddleware from 'redux-saga'

import app from './Reducers/index'
import rootSaga from './Sagas/rootSaga'

const sagaMiddleware = createSagaMiddleware()

const migrations = {
  2: (state) => {
    return {
      ...state,
      mainReducer: {
        ...state.mainReducer,
        dashboard_filters: {
          hello: true,
          user_status: true,
          user_top_links: true,
          activity: true,
          attendance: true,
          accounting: false,
          fee: true,
          news: true,
          schedule: true,
          weeklySchedule: true,
        },
      },
    }
  },
}

const persistedReducer = persistReducer(
  {
    key: import.meta.env.VITE_APP_REDUX_STATE_KEY,
    storage: localforage,
    version: 2,
    migrate: createMigrate(migrations, {debug: true}),
    // UI-only state: a reload must not bring back a popup or a stale network banner
    blacklist: ['connectivityReducer', 'sampleReadOnlyReducer'],
  },
  app
)

export default function configureStore() {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

  const sentryReduxEnhancer = Sentry.createReduxEnhancer()

  const store = createStore(
    persistedReducer,
    undefined,
    composeEnhancers(applyMiddleware(sagaMiddleware), sentryReduxEnhancer)
  )
  sagaMiddleware.run(rootSaga)

  const persistor = persistStore(store)

  return {store, persistor}
}
